<template>
	<div>
		<el-container>
			<el-container>
				<el-main>
					<div class="search-box clearfix">
						<el-form class="form-main" ref="searchForm" :model="searchForm" size="mini" inline label-width="80px" label-position="right">
							<span>
								<el-form-item label="房间" property="roomId">
									<el-cascader
										placeholder="请选择房间"
										:options="TreeData"
										v-model="searchForm.roomId"
										:props="{ value: 'id', label: 'name', children: 'children' }"
										filterable
										clearable
										ref="myCascader"
									>
									</el-cascader>
								</el-form-item>
								<el-form-item label="工号" property="personNo">
									<el-input
										v-model="searchForm.personNo"
										placeholder="请输入工号"
										clearable
										@keyup.enter.native="get_student"
									>
									</el-input>
								</el-form-item>
								<el-form-item label="姓名" property="personName">
									<el-input
										v-model="searchForm.personName"
										placeholder="请输入姓名"
										clearable
										@keyup.enter.native="get_student"
									>
									</el-input>
								</el-form-item>
								<el-form-item label="日期范围" property="dateRange">
									<span>
										<el-date-picker
											v-model="dateRange"
											type="daterange"
											align="right"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											unlink-panels
											range-separator="至"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											:picker-options="pickerOptions"
											@change="get_baobiao"
										/>
									</span>
								</el-form-item>
							</span>

							<div class="search-box-button search-button search_box_button_right">
							<el-button size="mini" type="primary" @click.native.prevent="get_baobiao(true)">查 询</el-button>
							<el-button size="mini"  @click="resetSearchForm">重 置</el-button>
							</div>

						</el-form>
						</div>
						<hr class="search_border">
						<div class="search_tools_div">
						<div class="search_tools_text">交易列表
							<span style="margin-left: 15px">总条数： {{totalObj.totalCount ? totalObj.totalCount : 0 }}</span>
							<span style="margin-left: 15px">总金额： {{totalObj.totalMoney ? totalObj.totalMoney : 0 }}</span>
						</div>
						<div class="search-tools">
							<el-button type="primary" @click="exportExcel">导出</el-button>
						</div>
					</div>
					<el-table
					  v-loading='loading'
					  ref="multipleTable"
					  :data="tableData"
					  tooltip-effect="dark"
					  :height="tableHeight"
					  border
					  stripe
					  @selection-change="handleSelectionChange">
						<el-table-column prop="index" type="index" label="序号" align="center" width="80"></el-table-column>
						<el-table-column prop="orderId" label="订单号" align="center" show-overflow-tooltip=""></el-table-column>
						<el-table-column prop="roomAllName" label="房间" align="center">
							<template slot-scope="scope">
								{{scope.row.buildingName }}-{{scope.row.roomNo }}
							</template>
						</el-table-column>
						<el-table-column prop="personName" label="姓名" align="center"></el-table-column>
						<el-table-column prop="personNo" label="工号" show-overflow-tooltip align="center"></el-table-column>
						<!-- <el-table-column prop="inBalance" label="充值前余额" align="center"></el-table-column> -->
						<el-table-column prop="dealMoney" label="充值金额" align="center"></el-table-column>
						<!-- <el-table-column prop="outBalance" label="充值后余额" align="center"></el-table-column> -->
						<el-table-column prop="dealFlag" label="状态" align="center">
							<template slot-scope="scope">
								<el-tag type="primary" v-if="scope.row.dealFlag == '1'">支付成功</el-tag>
								<el-tag type="danger" v-else-if="scope.row.dealFlag == '2'">支付失败</el-tag>
								<el-tag type="warning" v-else>未支付</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="dealTime" label="交易时间" align="center"></el-table-column>
					</el-table>

					<el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  layout="total, sizes, prev, pager, next, jumper"
					  :page-sizes="[10, 20, 50, 100]"
					  :current-page="current"
					  :page-size="size"
					  :total="total">
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

	</div>
</template>

<script>
// 充值统计报表
import { getStutList, getTree, get_stu_export, getczList, exportCzList } from '@/apis/orange'
import { mapGetters, mapActions } from 'vuex';

export default {
	name: "Baobiaostu",	// 报表
	data() {
		return {
			loading: false,
			nowDate: '',

			searchForm: {},
			dateRange: [],
			dateRangeMoren: [],		// 默认日期范围
			TreeData: [
				{id: 0, name: '数据加载中' }
			],
			delBtlStatu: true,

			total: 0,
			size: 10,
			current: 1,

			totalObj: {},
			tableData: [],

			permDialogVisible: false,
			permForm: {},
			defaultProps: {
				children: 'children',
				label: 'machineNum'
			},
			treeSelectLocationId: 0,
			selectedMachineInfo: '',

			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}]
			},
		}
	},
	computed: {
		...mapGetters('treeData', ['treeData']),
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		}
	},
	created() {
		this.fetchTreeData().then(data => {
			this.TreeData = data
		});
		let t = new Date()
		let tPre = new Date((new Date() - 7 * 24 * 60 * 60 * 1000))
		let startDate = tPre.getFullYear() + '-' + ('0'+(tPre.getMonth() + 1)).slice(-2) + '-' + ('0' + tPre.getDate()).slice(-2)
		// let startDate = t.getFullYear() + '-' + ('0'+(t.getMonth() + 1)).slice(-2) + '-' + ('0' + t.getDate()).slice(-2)
		let endDate = t.getFullYear() + '-' + ('0'+(t.getMonth() + 1)).slice(-2) + '-' + ('0' + t.getDate()).slice(-2)
		this.nowDate = endDate
		this.dateRange = [startDate, endDate]
		this.dateRangeMoren = [startDate, endDate]
		this.get_baobiao()
		// this.getLocationTree()
	},
	methods: {
		...mapActions('treeData', ['fetchTreeData']),
		resetSearchForm() {
			this.searchForm = {}
			this.current = 1
			this.get_baobiao()
		},
		exportExcel() {
			const loading = this.$loading({
				text: '加载中...',
			});
			let searchObj = {}
			searchObj = JSON.parse(JSON.stringify(this.searchForm))
			if (searchObj.roomId && searchObj.roomId.length) {
				let room = searchObj.roomId[ searchObj.roomId.length - 1 ].toString()
				searchObj.roomLocationId = room
				delete searchObj.roomId
			} else {
				delete searchObj.roomId
			}
			exportCzList({...searchObj, beginDate: this.dateRange[0]?this.dateRange[0]:this.dateRangeMoren[0],
					endDate: this.dateRange[1]?this.dateRange[1]:this.dateRangeMoren[1]}).then(res => res.data).then(res => {
				loading.close()
				if (res.code == 200) {
					if (res.data.length) {
						let excelData = res.data.map((it, index) => ({index: index + 1,orderId: it.orderId, fjmc: `${it.buildingName}-${it.roomNo}`, mc: it.personName, personNo: it.personNo, dealMoney:it.dealMoney, time: it.dealTime }))
                        this.getExcel(excelData)
					} else {
						this.$message({
							type: 'error',
							message: "没有可导数据"
						})
					}
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		getExcel(excelData) {
            var XLSX = require("xlsx");

            // 创建一个工作表
            const worksheet = XLSX.utils.json_to_sheet(excelData)
            // 创建一个新的工作簿
            const workbook = XLSX.utils.book_new()

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Data')
            XLSX.utils.sheet_add_aoa(worksheet, [['序号','订单号', '房间', '姓名', '工号', '充值金额', '充值时间']], { origin: 'A1' })
            XLSX.writeFileXLSX(workbook, `房间充值记录${this.nowDate}.xlsx`)
        },
		getLocationTree() {
			getTree().then(res => res.data).then(res => {
				this.TreeData = this.adjustCascaderData(res.data)
			})
		},
		adjustCascaderData(data) {
			return data.map(item => {
				if (item.children && item.children.length == 0) {
					delete item.children; // 删除空的 children 数组
				} else {
					item.children = this.adjustCascaderData(item.children);
				}
				return item;
			});
		},
		arraySpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex ===4) { // 只对第二列（Category）进行合并
				if (rowIndex === 0) {
				return {
					rowspan: this.getRowSpan(row.category),
					colspan: 1,
				};
				} else {
					const prevRow = this.dialog.tableData[rowIndex - 1];
					if (prevRow.category === row.category) {
						return {
							rowspan: 0,
							colspan: 0,
						};
					} else {
						return {
							rowspan: this.getRowSpan(row.category, rowIndex),
							colspan: 1,
						};
					}
				}
			}
		},
		getRowSpan(category, startIndex = 0) {
			let count = 0;
			for (let i = startIndex; i < this.dialog.tableData.length; i++) {
				if (this.dialog.tableData[i].category === category) {
				count++;
				} else {
				break;
				}
			}
			return count;
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;

			this.delBtlStatu = val.length == 0
		},

		handleSizeChange(val) {
			this.size = val
			this.get_baobiao()
		},
		handleCurrentChange(val) {
			this.current = val
			this.get_baobiao()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false
			this.editForm = {}
		},
		handleCloseDialog() {
			this.dialog.dialogVisible = false
		},
		get_baobiao(resetPage = false) {
			// console.log(resetPage);
			if (resetPage) {
				this.current = 1; // 重置到第一页
			}
			this.loading = true
			let searchObj = {}
			searchObj = JSON.parse(JSON.stringify(this.searchForm))
			if (searchObj.roomId && searchObj.roomId.length) {
				let room = searchObj.roomId[ searchObj.roomId.length - 1 ].toString()
				// let floo = searchObj.roomId[ searchObj.roomId.length - 2 ] ? searchObj.roomId[ searchObj.roomId.length - 2 ].toString() : false
				// searchObj.roomId = floo ? room.split(floo)[1] : room
				// if (floo) {
				// 	searchObj.roomId = room.split(floo)[1]
				// } else if (room != 0) {
				// 	searchObj.roomId = room
				// }
				searchObj.roomLocationId = room
				delete searchObj.roomId
			} else {
				delete searchObj.roomId
			}
			getczList({current: this.current, size: this.size, ...searchObj, beginDate: this.dateRange[0]?this.dateRange[0]:this.dateRangeMoren[0],
					endDate: this.dateRange[1]?this.dateRange[1]:this.dateRangeMoren[1]
			}).then(res => res.data).then(res => {
				// console.log(res);
				this.loading = false
				this.tableData = res.data?res.data.records:[]
				this.total = res.data?res.data.total:0
				this.totalObj = res.total
			}).catch((err) => {
				// console.log(err);
				this.loading = false
			})
		},

		viewHandle(row) {
			const loading = this.$loading({
				text: '加载中...',
			});
			this.dialog.title = `扣费详情（${row.roomAllName}  /  ${row.dealTime}）`
			getStutList({
				// current: this.dialog.current, size: this.dialog.size, 
				beginDate: this.dateRange[0]?this.dateRange[0]:this.dateRangeMoren[0],
				endDate: this.dateRange[1]?this.dateRange[1]:this.dateRangeMoren[1],
				orderId: row.orderId
			}).then(res => res.data).then(res => {
				this.dialog.dialogVisible = true
				loading.close()
				this.dialog.tableData = res.data.records
				this.dialog.total = res.data.total
				this.dialog.loading = false
			})
		},
	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}
.border {
	width: 40px;
	height:40px;
	text-align: center; 
	line-height: 40px;
	border-radius: 50%;
	display: inline-block;
	cursor: pointer;
}
.green {
	border: 1px solid green;
	color: green;
}
.red {
	border: 1px solid red;
	color: red;
}

</style>